import React from 'react';
import reduce from 'lodash/reduce';
import take from 'lodash/take';
import classNames from 'classnames';

import {GRID_TYPE} from 'eventbrite_design_system/mediaCardContent/constants';
import EventCard from 'eventbrite_design_system/eventCard/EnhancedEventCard';

import {OnboardingEntry} from '@eb/destination-utils';

import {
    GA_HOME_FEED_CATEGORY,
    GA_ONBOARDING_START_ACTION,
    TRACKING_CODE,
} from '../constants/analytics';

import {trackFeedEvent} from '../redux/app/actions';

import './ConsumerOnboardingCard.scss';


const _handleOnboardingClick = () => {
    trackFeedEvent({
        action: GA_ONBOARDING_START_ACTION,
        category: GA_HOME_FEED_CATEGORY,
        onWindowUnload: true,
    });
};

const _insertOnboardingCard = ({
    cardsComponent,
    eventCardContainerClassName,
    isAuthenticated,
    isInOddLayout,
}) => {
    const [card1, card2, card3, ...remainingCards] = cardsComponent;

    let cardsWithOnboarding = [
        card3,
        (
            <OnboardingEntry
                type="standardPurple"
                containerClasses={eventCardContainerClassName}
                key="onboarding-entry"
                isAuthenticated={isAuthenticated}
                onButtonClick={_handleOnboardingClick.bind(null, {isAuthenticated})}
            />
        ),
    ];

    if (isInOddLayout) {
        cardsWithOnboarding = [
            (
                <OnboardingEntry
                    type="standardPurple"
                    containerClasses={eventCardContainerClassName}
                    key="onboarding-entry"
                    isAuthenticated={isAuthenticated}
                    onButtonClick={_handleOnboardingClick.bind(null, {isAuthenticated})}
                />
            ),
            card3,
        ];
    }

    const _cardsComponent = [
        card1,
        card2,
        ...cardsWithOnboarding,
        ...take(remainingCards, remainingCards.length),
    ];

    return _cardsComponent;
};

const ConsumerCards = ({
    bucketKey,
    bucketLayoutConfig,
    eventsGroups,
    isAuthenticated,
    onViewEvent,
    onSaveEvent,
    visible,
    onAddOrRemoveEventToCollection,
    onCreateCollection,
    userCollections,
    isFreeTab,
    shouldShowOnboardingEntryPoint,
    cardType,
    isFirstBucket,
    isInOddLayout,
    shareOptions,
}) => {
    const bucketClassNames = bucketLayoutConfig && bucketLayoutConfig.bucketClassNames || '';

    let cardsComponent = reduce(eventsGroups, (memo, {events, containerClasses}) => {
        const eventCardsComponents = events.map(({
            id,
            isFree,
            imageUrl,
            ...cardProps
        }) => (
            <div className={containerClasses} key={id}>
                <EventCard
                    id={id}
                    onClick={onViewEvent.bind(null, id, bucketKey)}
                    onSaveEvent={onSaveEvent}
                    isAuthenticated={isAuthenticated}
                    excludeDateThumbnail={true}
                    hidePriceDescription={true}
                    onAddOrRemoveEventToCollection={onAddOrRemoveEventToCollection}
                    onCreateCollection={onCreateCollection}
                    userCollections={userCollections}
                    isConsumer={true}
                    isLazyImage={!visible}
                    {...cardProps}
                    isFree={!isFreeTab && isFree}
                    imageUrl={imageUrl}
                    shareOptions={{
                        ...shareOptions,
                        eventUrl: cardProps.url,
                        trackingCode: TRACKING_CODE,
                    }}
                />
            </div>
        ));

        return [
            ...memo,
            ...eventCardsComponents,
        ];
    }, []);

    if (isFirstBucket && shouldShowOnboardingEntryPoint) {
        const eventCardContainerClassName = classNames(
            'feed__card-cell',
            'eds-g-cell eds-g-cell--has-overflow eds-g-cell-1-1',
            {
                'eds-g-cell-sm-6-12 eds-g-cell-mn-4-12 eds-g-cell-lg-3-12': cardType === GRID_TYPE,
            }
        );

        cardsComponent = _insertOnboardingCard({
            cardsComponent,
            eventCardContainerClassName,
            isAuthenticated,
            isInOddLayout,
        });
    }

    return (
        <div className={bucketClassNames}>
            {cardsComponent}
        </div>
    );
};

export default ConsumerCards;
